const ITEMS = [
    "Planos a partir de R$ 99/mês",
    "Seu custo não precisa crescer junto com seus benefícios",
    "Uma empresa. Uma plataforma.",
    "Mais previsibilidade para sua empresa",
    "Mais controle para o RH",
    "Gestão centralizada de benefícios",
];

function Row() {
    return (
        <div className="flex shrink-0 items-center">
            {ITEMS.map((item, i) => (
                <span key={i} className="flex items-center">
                    <span className="whitespace-nowrap px-7 font-display text-sm font-semibold uppercase tracking-[0.18em] text-white md:text-base">
                        {item}
                    </span>
                    <svg width="10" height="10" viewBox="0 0 10 10" className="shrink-0" aria-hidden="true">
                        <rect x="1.7" y="1.7" width="6.6" height="6.6" rx="1" transform="rotate(45 5 5)" fill="#FF7A44" />
                    </svg>
                </span>
            ))}
        </div>
    );
}

export default function Marquee() {
    return (
        <div className="marquee bg-azul-950 py-5" data-testid="marquee-mensalidade">
            <div className="marquee-track">
                <Row />
                <Row />
            </div>
        </div>
    );
}
